import React from "react";
import {useWebGL} from "../hooks/useWebGL";
import WebGLUnavailable from "./WebGLUnavailable";

export type WithWebGLProps = { children: React.ReactNode };

const WithWebGL: React.FC<WithWebGLProps> = ({children}) => {
  const {supported, checked} = useWebGL();

  if (!checked) return null;
  if (!supported) return <WebGLUnavailable/>;

  return <>{children}</>;
}

export default WithWebGL;